module.exports = __webpack_public_path__ + "img/chevron-down-light.5781a9b2.svg";